import React from 'react';
import { Award, HeartHandshake, Shield, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Award,
  HeartHandshake,
  Shield,
  Sparkles
};

const WhyChooseUs = () => {
  const features = [
    {
      icon: 'Award',
      title: '10 Años de Experiencia',
      titleEn: '10 Years of Experience',
      description: '10 años nos avalan organizando viajes de esquí para nuestros queridos pasajeros',
      descriptionEn: '10 years of experience organizing ski trips for our beloved travelers'
    },
    {
      icon: 'HeartHandshake',
      title: 'Atención Personalizada',
      titleEn: 'Personalized Service',
      description: 'Diseñamos cada viaje según tus necesidades y preferencias',
      descriptionEn: 'We design each trip according to your needs and preferences'
    },
    {
      icon: 'Shield',
      title: 'Confianza y Seguridad',
      titleEn: 'Trust and Safety',
      description: 'Tu tranquilidad es nuestra prioridad en cada detalle del viaje',
      descriptionEn: 'Your peace of mind is our priority in every detail of the trip'
    },
    {
      icon: 'Sparkles',
      title: 'Experiencias Inolvidables',
      titleEn: 'Unforgettable Experiences',
      description: 'Creamos momentos mágicos en la nieve que recordarás para siempre',
      descriptionEn: 'We create magical moments in the snow that you will remember forever'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#003580] mb-4">
            ¿Por Qué Elegirnos?
          </h2>
          <p className="text-xl text-gray-600">Why Choose Us?</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <Card
                key={index}
                className="border-2 border-gray-100 hover:border-[#FF6B35] transition-all duration-300 hover:shadow-xl transform hover:-translate-y-2 group"
              >
                <CardContent className="p-8 text-center space-y-4">
                  <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-50 group-hover:bg-[#FF6B35] transition-colors duration-300">
                    <IconComponent className="w-10 h-10 text-[#003580] group-hover:text-white transition-colors duration-300" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-xl font-bold text-[#003580]">{feature.title}</h3>
                    <p className="text-sm font-semibold text-[#FF6B35]">{feature.titleEn}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-700 leading-relaxed">{feature.description}</p>
                    <p className="text-sm text-gray-500 leading-relaxed">{feature.descriptionEn}</p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
